import React from 'react';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LegalLayout from './LegalLayout';

const Privacy = () => (
  <LegalLayout title="Privacy Policy" updated="7 July 2026">
    <p>
      This policy explains what Budget Clues collects, why, and what control you have over it. The
      short version: we collect only what the app needs to work, we don't sell your data, and you can
      delete everything at any time.
    </p>

    <h2>What we collect</h2>
    <ul>
      <li>
        <strong>Account details:</strong> your email address, and if you sign in with Google or
        Microsoft, the name and profile picture those providers share.
      </li>
      <li>
        <strong>Financial data you add:</strong> transactions you enter manually or import from CSV
        files, plus the categories, budgets, rules and goals you create.
      </li>
      <li>
        <strong>Bank data you connect:</strong> if you link a bank through Akahu, we receive account
        balances and transactions for the accounts you consent to share. We never see your bank login
        credentials.
      </li>
    </ul>

    <h2>How we use it</h2>
    <p>
      Your data is used solely to run the app: showing your transactions, calculating budgets and
      insights, and keeping you signed in. We do not sell your data, share it with advertisers, or use
      it for any purpose unrelated to the Service.
    </p>

    <h2>Cookies and sign-in</h2>
    <p>
      We use an authentication cookie (and local storage) to keep you signed in. We don't use
      third-party advertising or tracking cookies. Signing in with Google or Microsoft is handled by
      Firebase Authentication, which processes your sign-in under its own terms.
    </p>

    <h2>Third parties we rely on</h2>
    <ul>
      <li><strong>Akahu:</strong> secure bank connections (only if you choose to connect a bank).</li>
      <li><strong>Firebase (Google):</strong> sign-in with Google and Microsoft accounts.</li>
      <li><strong>Hosting providers:</strong> the servers and database that store your data.</li>
    </ul>

    <h2>Retention and deletion</h2>
    <p>
      We keep your data for as long as your account exists. Deleting your account from Settings
      removes your transactions, categories, budgets, rules, accounts and settings from our database
      and revokes any Akahu bank connection. This is immediate and irreversible.
    </p>

    <h2>Security</h2>
    <p>
      Passwords are stored as salted hashes, traffic is encrypted in transit, and bank access tokens
      are held server-side only. No system is perfectly secure, but we design so that a lost device or
      leaked password exposes as little as possible. You can sign out everywhere from Settings.
    </p>

    <h2>Your rights</h2>
    <p>
      You can access, correct, export or delete your data at any time from within the app. For
      anything you can't do yourself, or any privacy question, contact{' '}
      <a href="mailto:support@budgetclues.app">support@budgetclues.app</a>. See also our{' '}
      <Link component={RouterLink} to="/terms">Terms of Service</Link>.
    </p>
  </LegalLayout>
);

export default Privacy;
